<script>
import { mapGetters } from 'vuex';
import Segment from '@/Segment';
import { openOnboardingAssistant } from '@/chat-boot/assistantLauncher';

// Adds an "אני אשמח לעזרה" entry to a ConnectionFailureBase-style `buttons` array, for
// onboarding screens that had no support affordance at all. Spread `assistantButtons`
// into the array so the button disappears entirely while the flag is off, rather than
// appearing and opening Intercom. Hosts must define an `assistantInitiator` computed.
export default {
  name: 'OnboardingAssistantButton',
  computed: {
    ...mapGetters('featureFlags', ['onboardingAssistant']),
    assistantButtons() {
      if (!this.onboardingAssistant) {
        return [];
      }
      return [{
        action: this.openAssistantFromOnboarding,
        title: 'אני אשמח לעזרה',
        variant: 'secondary',
        size: 'slim',
        // eslint-disable-next-line global-require
        icon: require('@/assets/icons/chat_icon_teriatry.svg'),
      }];
    },
  },
  methods: {
    openAssistantFromOnboarding() {
      Segment.trackUserInteraction('OnboardingAssistant_Clicked', { source: this.assistantInitiator });
      openOnboardingAssistant({ initiator: this.assistantInitiator });
    },
  },
};
</script>
